import { useMemo } from 'react'
import useAsync from './useAsync'
import useSafeInfo from './useSafeInfo'
// import { getSystemTxns, type SystemHistoryGrouped, type SystemTxns } from '@/utils/routescan'
import { getSystemHistory, type SystemHistoryGrouped } from '@/utils/api'
import { useCurrentChain } from './useChains'

const useSystemHistory = (
  refreshCounter: number,
): {
  page?: SystemHistoryGrouped[]
  error?: string
  loading: boolean
} => {
  const { safeAddress } = useSafeInfo()
  const chainInfo = useCurrentChain()

  // If filter exists or pageUrl is passed, load a new history page from the API
  const [page, error, loading] = useAsync<SystemHistoryGrouped[]>(
    () => {
      if (!chainInfo || refreshCounter === 0) return

      // return getSystemTxns(safeAddress, chainInfo)
      return getSystemHistory(chainInfo.chainId, safeAddress)
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [chainInfo, safeAddress, refreshCounter],
    false, // don't clear data between polls
  )

  return useMemo(
    () => ({
      page,
      error: error?.message,
      loading,
    }),
    [page, error, loading],
  )
}

export default useSystemHistory
